// extracted by mini-css-extract-plugin
module.exports = {"SearchInput":"SearchPage_SearchInput__3McID","EnterToSearch":"SearchPage_EnterToSearch__3NQzr","AlgoliaSearch":"SearchPage_AlgoliaSearch__1lxmG"};